import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { EmployeeService } from '../employee.service';
import { Observable,Subject } from "rxjs";
import {MatTableDataSource,MatPaginator} from '@angular/material';
import * as XLSX from 'xlsx';
import {SelectionModel} from '@angular/cdk/collections';
import { DatePipe } from '@angular/common'

export interface Approval {
  name : string;
  revieweddate: Date;
  notes: string;
  itemId: string;
  description: string;
  qty: string;
  uom: string;
  isApproved: string;
  
}




@Component({
  selector: 'app-reorder-status',
  templateUrl: './reorder-status.component.html',
  styleUrls: ['./reorder-status.component.css']
})
export class ReorderStatusComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[] = ['name', 'revieweddate', 'notes', 'itemId', 'description', 'qty', 'uom', 'isApproved'];
  dataSource = new MatTableDataSource<Approval>();
  maxall : number=20;
  

  constructor(private employeeservice:EmployeeService,public datePipe:DatePipe) { }
  reorderstatuses: Observable<EmployeeService[]>;
  date : Date = null;
  approvalstatuslist: any[];
  isSelect = false;
  reorderstatus:string = '';
  reorderStatusList: any;
  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.employeeservice.getAprovalStatusList().subscribe(data =>{
      this.reorderstatuses =data;
      console.log(this.reorderstatuses);
      
      });
  }

  onSelect(val:any){
    this.date = val;
    this.reorderStatusList = [];
    if(val != '') {
      this.employeeservice.getApprovalStatusBydate(this.date)
        .subscribe(res => {
        //  this.isSelect=true;
        this.reorderStatusList = res;
          this.dataSource.data = res as Approval[];
        //  console.log(res)
        })
    }
  }
  submit(){
    console.log(this.date);
    
        this.employeeservice.getApprovalStatusBydate(this.date)
        .subscribe(res => {
          this.isSelect=true;
          this.dataSource.data = res as Approval[];
          console.log(res)
        })
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.paginator.length>this.maxall)
    return [5, 10, 20,  this.dataSource.paginator.length];
    else
    return [5, 10, 20, this.maxall];
    }
    
  exportToExcel() {
	if(this.reorderStatusList.length>0){
		let excelObj = [];
	let datePipe1: DatePipe = new DatePipe('en-US');
	this.reorderStatusList.forEach(function(obj){
	
			obj.lineItems.forEach(function(innerObj){
				
			let newObj:any = {};
			let x = new Date(obj.orderedDate);
			newObj.orderId=obj.orderId;
     		newObj.orderedDate=obj.orderedDate;
     		newObj.employeeName=obj.firstName + " " + obj.lastName;
     		newObj.sku=innerObj.itemId;
     		newObj.description=innerObj.itemDescription;
     		newObj.qty=innerObj.qty;
			newObj.um=innerObj.um;	
			newObj.approved=innerObj.approved;
			newObj.notes=obj.notes;
			excelObj.push(newObj);
			})
			
	})
	

  let workSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelObj, <XLSX.Table2SheetOpts>{ sheet: 'Sheet 1' });
  let workBook: XLSX.WorkBook = XLSX.utils.book_new();

  // Adjust column width
  var wscols = [
    { wch: 50 },
    { wch: 50 },
    { wch: 30 }
  ];

  workSheet["!cols"] = wscols;

  XLSX.utils.book_append_sheet(workBook, workSheet, 'Reorder_Status');
  XLSX.writeFile(workBook, 'Reorder_Status.xlsx');
		
	}
	
	
}
}
